import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { colors, s } from "../lib/theme";

export default function SetupPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [callsign, setCallsign] = useState(null);
  const [invalidReason, setInvalidReason] = useState(null);

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.checkSetupToken(token)
      .then((data) => setCallsign(data.callsign))
      .catch((err) => setInvalidReason(err.message))
      .finally(() => setChecking(false));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    if (newPassword !== confirmPassword) return setError("Las dos contraseñas no coinciden");
    setSaving(true);
    try {
      await api.setupPassword(token, newPassword);
      setSuccess(true);
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", padding: "60px 20px" }}>
      <div style={{ width: 380, background: colors.panelRaised, border: `1px solid ${colors.lineStrong}`, borderRadius: 14, padding: "34px 32px" }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 14 }}>
          <img src="/brand/icon-flat-white.svg" alt="Centinel DX" width={44} height={44} />
        </div>
        <div style={{ textAlign: "center", fontSize: 20, fontWeight: 700, color: colors.text, marginBottom: 22 }}>
          Define tu contraseña
        </div>

        {checking && <p style={{ color: colors.textDim, textAlign: "center" }}>Comprobando enlace…</p>}

        {!checking && invalidReason && (
          <div style={s.errorBox}>{invalidReason} — pide al superadministrador que te reenvíe la invitación.</div>
        )}

        {!checking && !invalidReason && !success && (
          <form onSubmit={submit}>
            <p style={{ color: colors.textDim, fontSize: 13.5, marginBottom: 18 }}>
              Indicativo: <b style={{ color: colors.text }}>{callsign}</b>
            </p>
            <label style={s.label}>NUEVA CONTRASEÑA</label>
            <input type="password" style={{ ...s.input, marginBottom: 14 }} value={newPassword} onChange={(e) => setNewPassword(e.target.value)} autoFocus />
            <label style={s.label}>REPITE LA CONTRASEÑA</label>
            <input type="password" style={s.input} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />

            {error && <div style={{ ...s.errorBox, marginTop: 16 }}>{error}</div>}

            <button type="submit" disabled={saving} style={{ ...s.btnPrimary, width: "100%", justifyContent: "center", marginTop: 22, opacity: saving ? 0.6 : 1 }}>
              {saving ? "Guardando…" : "Guardar y entrar"}
            </button>
          </form>
        )}

        {success && (
          <div style={{ textAlign: "center", color: colors.green, fontSize: 14, fontWeight: 600 }}>
            ✓ Contraseña definida. Te llevamos al login…
          </div>
        )}
      </div>
    </div>
  );
}
